module.exports = __webpack_public_path__ + "static/img/klp1360-663-370gld.9bb579e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/klp1360-663-370gld.jpg
// module id = 0Sky
// module chunks = 0